import { RadioInputGroup, RadioInput } from "@instructure/ui";
import { useTranslation } from "react-i18next";

const GroupByToggle = ({ value, onChange, label }) => {
  const { t } = useTranslation();

  return (
    <div className="GroupByToggle">
      <style>{`.GroupByToggle fieldset { row-gap: 1.3rem !important; }`}</style>
      <RadioInputGroup
        name="groupByToggle"
        value={value}
        onChange={(_e, newValue) => onChange(newValue)}
        description={label || t("assessmentPlanningDashboard.groupBy.label")}
        layout="columns"
      >
        <RadioInput
          label={t("assessmentPlanningDashboard.sectionFilter")}
          value="section"
        />
        <RadioInput
          label={t("assessmentPlanningDashboard.groupBy.goalObjective")}
          value="goalObjective"
        />
      </RadioInputGroup>
    </div>
  );
};

export default GroupByToggle;
